<span class="ping">
  @if (offline) {
    <mat-icon [svgIcon]="iconBase + '-0'" class="fs"></mat-icon>
    <mat-icon class="fs off">highlight_off</mat-icon>
  } @else {
    @if (!score) {
      <mat-icon [svgIcon]="iconBase + '-0'" class="fs"></mat-icon>
    } @else {
      <mat-icon [svgIcon]="iconBase + '-' + (score >= 4 ? '4' : score)" class="fs"></mat-icon>
    }
  }
</span>
